export const CREATE_TRANSACTION_LINK = (id) => `/workshop/transaction/${id}/link`;
